let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("94PYa")).then(() => parcelRequire('3SYc6'));